import { useFormik } from 'formik';
import { useEffect } from 'react';
import {
  LoadCanvasTemplate,
  loadCaptchaEnginge,
  validateCaptcha,
} from 'react-simple-captcha';
import { useAuth } from 'hooks';
import { Button, Input } from 'components';
import * as S from './styles';

interface Props {
  setIsBot: (isBot: boolean) => void;
}

export function Captcha({ setIsBot }: Props) {
  const { signOut } = useAuth();
  useEffect(() => {
    loadCaptchaEnginge(4, '#f2f2f2', '#010101');
  }, []);

  const handleSubmit = (values: { captcha: String }) => {
    const { captcha } = values;

    if (validateCaptcha(captcha) === true) {
      setIsBot(false);
    }
  };

  const formCaptcha = useFormik({
    initialValues: { captcha: '' },
    onSubmit: (values) => handleSubmit(values),
  });

  return (
    <S.Main>
      <S.Background />

      <S.Container>
        <S.Wrapper>
          <LoadCanvasTemplate reloadText="Recarregar" reloadColor="#FF8A00" />

          <form onSubmit={formCaptcha.handleSubmit}>
            <Input
              type="text"
              name="captcha"
              onChange={formCaptcha.handleChange}
              value={formCaptcha.values.captcha}
            />

            <Button type="submit" full>
              Enviar
            </Button>
            <Button onClick={signOut} type="button" variant="link" full>
              SAIR
            </Button>
          </form>
        </S.Wrapper>
      </S.Container>
    </S.Main>
  );
}
